module.exports = __webpack_public_path__ + "img/viber.a9b71088.svg";